import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import {
  Button,
  Offcanvas,
  OverlayTrigger,
  Tooltip,
  Dropdown,
  Row,
  Col,
  Tabs,
  Tab,
  Card,
} from "react-bootstrap";
// import "./View_ProjectDetails.css";
import {
  IconCalendarWeek,
  IconChevronDown,
  IconCopy,
  IconChevronRight,
  IconCopyCheck,
  IconEdit,
  IconFileTypePdf,
  IconPhoto,
  IconMail,
  IconMapPin,
  IconPaperclip,
  IconPhone,
  IconLink,
  IconShare,
  IconUser,
  IconFileTypeDoc,
  IconFileTypeXls,
  IconClockHour3,
  IconUserCircle,
  IconRefreshDot,
  IconEye,
  IconUpload,
} from "@tabler/icons-react";
import moment from "moment";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { canAccessBatchImport } from "../../../utils/permissionUtils";
import KOorCustomerEmailDialog from "../Email/KOorCustomerEmailDialog";
import SuccsessMsgModal from "../../../components/SuccessMsgModal";
// import CopyOpportunityDialog from "../CopyOpportunity/CopyOpportunityDialog";
import ComanConfirmationModal from "../../../components/ComanConfirmationModal";
import usePostRequest from "../../../hooks/usePostRequest";
import axiosInstance from "../../../api/axiosInstance";
import { API_ENDPOINTS, truncateFormat } from "../../../constant/_constant";
import { toast } from "react-toastify";
import Lottie from "lottie-react";
import notfoundData from "../../../assets/not_found.json";
import { useLocation } from "react-router-dom";
import PriceChangesModal from "../PriceChange/PriceChangesModal";
import UploadStepPopupCv from "../BatchImport/UploadStepPopupCv";
import ReviewProductsPopupCv from "../BatchImport/ReviewProductsPopupCv";
import { trimTrailingZeros } from "../../../utils/_helpers";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const IMG = process.env.REACT_APP_BASE_URL_IMG;
const items = [
  "Item 1",
  "Item 2",
  "Item 3",
  "Item 4",
  "Item 5",
  "Item 6",
  "Item 7",
  "Item 8",
  "Item 9",
];

const ITEMS_PER_VIEW = 3.5;

const generateUniqueId = () => {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  let result = "";
  for (let i = 0; i < 8; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters.charAt(randomIndex);
  }

  const timestamp = Date.now().toString();
  const uniqueId = result + timestamp.slice(-4);
  return uniqueId;
};

function View_ProjectDetails({
  // show,
  // setShow,
  // opportunity,
  isStatusUpdate,
  onStatusUpdate,
  triggerCardHighlight,
}) {
  const user = useSelector((state) => state.auth.user);
  const hasBatchImportAccess = canAccessBatchImport(user);
  const statusOptions = [
    { value: "PENDING", label: "Pending", color: "#f4a100" },
    { value: "ACTIVE", label: "Active", color: "#28a745" },
    { value: "COMPLETED", label: "Completed", color: "#28a745" },
    { value: "DRAFT", label: "Draft", color: "#818183ff" },
  ];

  const navigate = useNavigate();

  const [opportunity, setOpportunity] = useState(null);
  const [isUploadOpen, setIsUploadOpen] = useState(false);
  const [isImportSummaryOpen, setIsImportSummaryOpen] = useState(false);
  const [importSummary, setImportSummary] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState({
    show: false,
    action: null,
    message: "",
  });

  const [isPriceOpen, setIsPriceOpen] = useState({
    show: false,
    onSuccessFetch: false,
  });

  const [formId, setFormId] = useState(null);

  useEffect(() => {
    const newFormId = generateUniqueId();
    setFormId(newFormId);
    // reset();
  }, []);

  const [show, setShow] = useState(false); // Local state to control the popup

  // console.log("opportunity data", opportunity);

  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const rfqId = searchParams.get("rfq_id");

  // console.log("rfqId from query params:", rfqId);

  // console.log("Full URL:", window.location.href);
  // console.log("location.search:", window.location.search);

  const { data: fetchedProject, postData: fetchProject } = usePostRequest(
    API_ENDPOINTS.GET_SINGLE_PROJECT,
  );

  useEffect(() => {
    if (window.location.search) {
      const searchParams = new URLSearchParams(window.location.search);
      const rfqId =
        searchParams.get("rfq_id") ||
        window.location.search.slice(1).split("&")[0];
      if (rfqId) {
        fetchProject({ rfq_id: rfqId, route_name: "view", route_type: "cv" });
      }
    }
  }, [window.location.search]);
  // useEffect(() => {
  //     if (window.location.search) {
  //         const rfqId = window.location.search.slice(1);
  //         //   console.log("rfqId to be used:", rfqId);
  //         fetchProject({ rfq_id: rfqId });
  //         // setOpportunity(fetchedProject?.data);
  //     }
  // }, [window.location.search]);

  useEffect(() => {
    if (fetchedProject?.data) {
      setOpportunity(fetchedProject.data);
      setShow(true);
    }
  }, [fetchedProject]);

  const handleClose = () => {
    setShow(false);
    const newUrl = window.location.pathname;
    window.history.pushState(null, "", newUrl);
  };

  // PARAMETER RFQ ID LOGIC
  // const { rfqId } = useParams();
  // const [opportunity, setOpportunity] = useState(null);

  // console.log("rfq id params",rfqId)

  // const { data: fetchedProject, postData: fetchProject } =
  //   usePostRequest(API_ENDPOINTS.GET_SINGLE_RFQ);

  // useEffect(() => {
  //   if (rfqId) {
  //     console.log("Fetching RFQ with ID:", rfqId);
  //     fetchProject({ rfq_id: rfqId });
  //   } else {
  //     console.log("Api not running")
  //   }
  // }, [rfqId]);

  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(statusOptions[0]);

  const [isSuccsessModalOpen, setIsSuccsessModalOpen] = useState({
    show: false,
    message: "",
    btntext: "Close",
    title: "Succsess",
  });

  const handleSelect = (option) => {
    setSelected(option);
    setIsOpen(false);
  };

  const { isLoading: removeLoading, postData: statusChange } = usePostRequest(
    API_ENDPOINTS.PROJECT_STATUS,
  );

  const { loadingdownLoad, postData: DownLoadFile } = usePostRequest(
    API_ENDPOINTS.DownLoadFile,
  );

  const { isLoading: createLoading, postData: createRFQCopy } = usePostRequest(
    API_ENDPOINTS.CREATE_RFQ,
  );

  const { data: fetchLink, postData: GetAttachment } = usePostRequest(
    API_ENDPOINTS.VIEW_ATTACHMENTS,
  );

  const onStatusSuccess = (response) => {
    toast.success("Project status updated successfully");
    setShow({ isStatusUpdate: true });
    if (onStatusUpdate) {
      onStatusUpdate();
    }
    triggerCardHighlight(response?.rfq_id);
    handleClose();
  };

  const onStatusError = (error) => {
    toast.error(error.message || "An error occurred during Status Change.");
  };

  // const downloadImage = (e, file_name) => {
  //   e.preventDefault();
  //   const imageUrl = `${BASE_URL}/common/download/${file_name}`;

  //   const link = document.createElement("a");
  //   link.href = imageUrl;
  //   link.setAttribute("download", "image.jpg");
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };

  useEffect(() => {
    if (fetchLink?.data) {
      window.open(fetchLink.data, "_blank");
    }
  }, [fetchLink]);

  const viewAttachment = async (e, attachmentId) => {
    e.preventDefault();
    try {
      await GetAttachment({ id: attachmentId });
    } catch (error) {
      console.error("Failed to view attachment", error);
    }
  };

  const downloadImage = async (e, item) => {
    e.preventDefault();

    try {
      const res = await GetAttachment({ id: item?.id });

      console.log("resres", fetchLink);

      const fileUrl = fetchLink?.data; // this is the returned URL
      if (!fileUrl) return;

      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = item?.original_name || "";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };
  // const downloadImage = async (e, item) => {
  //   e.preventDefault();

  //   const imageUrl = `${BASE_URL}/common/download/${item?.file_name}`;
  //   const customFileName = item.original_name;

  //   try {
  //     const response = await fetch(imageUrl, {
  //       method: "GET",
  //     });

  //     const blob = await response.blob();
  //     const blobUrl = window.URL.createObjectURL(blob);

  //     const link = document.createElement("a");
  //     link.href = blobUrl;
  //     link.setAttribute("download", customFileName || "download.jpg");
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //     window.URL.revokeObjectURL(blobUrl);
  //   } catch (error) {
  //     console.error("Download failed:", error);
  //   }
  // };

  const handleDownloadExcel = async () => {
    try {
      const response = await axiosInstance.post(
        API_ENDPOINTS.PROJECT_EXPORT,
        {
          rfq_id: opportunity?.rfq_id,
        },
        {
          responseType: "blob",
        },
      );

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `project_${opportunity?.rfq_id}_${moment().format("YYYY-MM-DD")}.xlsx`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Excel download failed:", error);
      toast.error("Excel download failed. Please try again.");
    }
  };

  const handleShareClick = () => {
    const baseUrl = window.location.origin;

    const fullUrl = `${baseUrl}/list-contract-vehicles?${opportunity?.rfq_id}`;

    // Check if the Clipboard API is available
    if (navigator.clipboard) {
      // Clipboard API is available, use it
      navigator.clipboard
        .writeText(fullUrl)
        .then(() => {
          // console.log("Link copied to clipboard");
          toast.success("Link copied to clipboard");
        })
        .catch((error) => {
          console.error("Failed to copy: ", error);
        });
    } else {
      // Fallback: Use a temporary textarea to copy text for browsers that do not support Clipboard API
      const textarea = document.createElement("textarea");
      textarea.value = fullUrl;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);

      toast.success("Link copied to clipboard");
    }
  };

  const ChangeStatusHandler = (rfqid, status) => {
    statusChange(
      { rfq_id: rfqid, rfq_status: status },
      onStatusSuccess,
      onStatusError,
    );
  };

  const openModal = (rfqid, status, Old_Status) => {
    let modalMessage = `Are you sure you want to change status to "${Old_Status} to ${status}"`;
    let modalTitle = "Change Status";
    let type = "success";
    let modalIcon = <IconRefreshDot stroke={1} />;
    let actionHandler = () => {
      ChangeStatusHandler(rfqid, status);
    };
    let action = "Change";
    setIsModalOpen({
      show: true,
      action,
      message: modalMessage,
      onConfirm: actionHandler,
      title: modalTitle,
      icon: modalIcon,
      type: type,
    });
  };

  const onSuccess = (res) => {
    setIsSuccsessModalOpen({
      show: true,
      title: "Project Created Successfully!",
      message: `Prepared by ID is ${res.rfq_id}. This Contract Vehicle is for ${
        res?.contract_type
      }. Created on ${moment(res?.created_date).format("MM/DD/YYYY")}.`,
      btntext: "Return Home",
    });
    if (onStatusUpdate) {
      onStatusUpdate();
    }
    handleClose();
  };

  const onError = (err) => {
    console.log("error", err);
  };

  const CopyOpportunityHandler = (opportunity) => {
    // console.log("opportunity", opportunity);
    const payload = {
      attachment_id: formId,
      rfq_id: "N/A",
      opportunity_type: opportunity?.opportunity_type || null,
      opportunity_name: opportunity?.opportunity_name || null,
      initial_consolidation: Number(opportunity?.initial_consolidation || 0),
      contract_type_id: Number(opportunity?.contract_type_id || 0),
      published_date: moment().format("YYYY-MM-DD"),
      start_date: opportunity?.start_date
        ? moment(opportunity.start_date).format("YYYY-MM-DD")
        : null,
      due_date: opportunity?.due_date
        ? moment(opportunity.due_date).format("YYYY-MM-DD")
        : null,
      project_duration: opportunity?.project_duration
        ? opportunity?.project_duration
        : null,
      project_budget: opportunity?.project_budget
        ? opportunity?.project_budget
        : null,
      parent_cv_id: Number(opportunity?.ContractType?.parent_id) || 0,
      // sales_lead_username: opportunity?.sales_lead_username || null,
      // sales_lead_name: opportunity?.sales_lead_name || null,
      // sales_lead_email: opportunity?.sales_lead_email || null,
      // sales_lead_phone: opportunity?.sales_lead_phone || null,
      // organization_name: opportunity?.organization_name || null,
      brief: opportunity?.brief || null,
      estimated_delivery: opportunity?.estimated_delivery || null,
      payment_term: opportunity?.payment_term || null,
      shipping_method: opportunity?.shipping_method || null,
      shipping_method_detail: opportunity?.shipping_method_detail || null,
      shipping_term: opportunity?.shipping_term || null,
      valid_for: opportunity?.valid_for || null,
      is_draft: true,
      shipping_cost: opportunity?.shipping_cost
        ? Number(opportunity.shipping_cost)
        : "0.00",
      tax: opportunity?.tax || "0.00",
      ko_detail: {
        name: opportunity?.rfqKo?.name || null,
        email: opportunity?.rfqKo?.email || null,
        phone: opportunity?.rfqKo?.phone || null,
        address: opportunity?.rfqKo?.address || null,
      },
      shipping_detail: {
        name: opportunity?.rfqShipping?.name || null,
        email: opportunity?.rfqShipping?.email || null,
        phone: opportunity?.rfqShipping?.phone || null,
        address: opportunity?.rfqShipping?.address || null,
      },
      billing_detail: {
        name: opportunity?.rfqBilling?.name || null,
        email: opportunity?.rfqBilling?.email || null,
        phone: opportunity?.rfqBilling?.phone || null,
        address: opportunity?.rfqBilling?.address || null,
      },

      point_of_contact: {
        name: opportunity?.point_of_contact?.name || null,
        email: opportunity?.point_of_contact?.email || null,
        phone: opportunity?.point_of_contact?.phone || null,
      },

      status: "DRAFT",
      otherCost: Array.isArray(opportunity?.other_cost_json)
        ? opportunity.other_cost_json
        : JSON.parse(opportunity?.other_cost_json || "[]"),

      price_changes: (opportunity?.RfqPriceChanges || []).map((change) => ({
        from_date: change?.from_date,
        to_date: change?.to_date,
        customer_price: change?.customer_price,
        margin_percent: change?.margin_percent,
      })),

      price_changes: (opportunity?.RfqPriceChanges || []).map((change) => ({
        from_date: change?.from_date,
        to_date: change?.to_date,
        customer_price: change?.customer_price,
        margin_percent: change?.margin_percent,
      })),

      custom_fields: (opportunity?.custom_fields || []).map((custom) => ({
        type: custom?.type,
        value: custom?.value,
        field_name: custom?.field_name,
      })),

      products: (opportunity?.RfqProducts || []).map((product) => ({
        vendor_name: product.Vendor?.display_name || null,
        sku_id: product.sku_id,
        description: product.description || null,
        quantity: Number(trimTrailingZeros(product.quantity) || 0),
        aspetto_price: Number(product.aspetto_price || 0),
        customer_price: Number(product.customer_price || 0),
        margin_percent: Number(product.margin_percent || 0),
        total_price: Number(product.total_price || 0),
        um: product.um || product.unit_of_measure || null,
      })),
      total_cost_before_margin: opportunity?.total_cost_before_margin
        ? Number(opportunity.total_cost_before_margin)
        : null,
      total_cost_after_margin: opportunity?.total_cost_after_margin
        ? Number(opportunity.total_cost_after_margin)
        : null,
    };

    // console.log("payload copy",payload)

    createRFQCopy(payload, onSuccess, onError);
  };

  const openModalCopy = (opportunity) => {
    let modalMessage = `Are you sure you want to copy this "${opportunity?.rfq_id}" Project`;
    let modalTitle = "Duplicate Project";
    let type = "success";
    let modalIcon = <IconCopy stroke={1} />;
    let actionHandler = () => {
      CopyOpportunityHandler(opportunity);
    };
    let action = "Change";
    setIsModalOpen({
      show: true,
      action,
      message: modalMessage,
      onConfirm: actionHandler,
      title: modalTitle,
      icon: modalIcon,
      type: type,
    });
  };

  useEffect(() => {
    if (opportunity?.status) {
      const match = statusOptions.find(
        (opt) => opt.value === opportunity.status,
      );
      if (match) {
        setSelected(match);
      }
    }
  }, [opportunity]);

  /*swiper*/

  /*swiper*/

  const handleOpenKOorCustomerEmailOpenDialog = (e) => {
    e.preventDefault();
    setIsEmaillOpen({ show: true });
  };

  const [isCopyQuoteOpen, setIsCopyQuoteOpen] = useState({
    show: false,
    Feild: "",
    rfq_id: "",
    btnText: "",
    label: "",
  });

  // const handleCopy_Quote = (selectedOption, rfq_id) => {
  //   navigate("/copy-quote", {
  //     state: {
  //       selectedCopy: selectedOption,
  //       rfqCopy: rfq_id,
  //     },
  //   });
  // };

  const [isEmaillOpen, setIsEmaillOpen] = useState({
    title: "",
    show: false,
    row: "",
    skuData: "",
    defaultSubject: "",
    Quote_No: "",
    RFQID: "",
    toEmail: "",
    toName: "",
  });

  const totalNotes = opportunity?.section.reduce((acc, section) => {
    return acc + section.notes.length;
  }, 0);

  const handleModalClose = () => {
    setShow({ show: false });
    navigate("/list-contract-vehicles");
  };

  return (
    <>
      <UploadStepPopupCv
        show={isUploadOpen}
        setShow={setIsUploadOpen}
        onNext={(data) => {
          setImportSummary(data);
          setIsImportSummaryOpen(true);
        }}
        rfqId={opportunity?.id}
      />
      <ReviewProductsPopupCv
        show={isImportSummaryOpen}
        setShow={setIsImportSummaryOpen}
        summaryData={importSummary}
        rfqId={opportunity?.id}
        // onApprove={(data) => {
        //   handleClearFilter();
        // }}
      />
      <Offcanvas
        name="Detail"
        show={show}
        // onHide={handleClose}
        // onHide={() => setShow({ show: false })}
        // onHide={handleModalClose}
        onHide={handleClose}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <div className="flex_profit_row">
              <p className="mb-0">
                <span className="profit_est">Est. Profit:</span> $
                {(() => {
                  const after = Number(opportunity?.total_cost_after_margin);
                  const before = Number(opportunity?.total_cost_before_margin);
                  const profit = after - before;
                  const percentage = after !== 0 ? (profit / after) * 100 : 0;
                  return `${truncateFormat(profit, 2)} (${truncateFormat(
                    percentage,
                    2,
                  )}%)`;
                })()}
              </p>
              <p className="mb-0 mt-0">
                <span className="profit_est">Est. Expenses:</span> $
                {Number(opportunity?.total_cost_after_margin)}
              </p>
            </div>
            <div className="flex_profit_row">
              <OverlayTrigger
                placement="bottom"
                overlay={
                  <Tooltip id="tooltip-disabled">Export Products</Tooltip>
                }
              >
                <span
                  onClick={handleDownloadExcel}
                  style={{ cursor: "pointer" }}
                >
                  <IconFileTypeXls />
                </span>
              </OverlayTrigger>

              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id="tooltip-disabled">Edit</Tooltip>}
              >
                <a
                  onClick={() =>
                    navigate(`/edit-contract-vehicle/${opportunity?.rfq_id}`)
                  }
                >
                  <IconEdit />
                </a>
              </OverlayTrigger>

              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id="tooltip-disabled">Copy URL</Tooltip>}
              >
                <span onClick={handleShareClick}>
                  <IconShare />
                </span>
              </OverlayTrigger>

              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id="tooltip-disabled">Duplicate</Tooltip>}
              >
                <span
                  onClick={() => openModalCopy(opportunity)}

                  // onClick={() => {
                  //   setIsCopyQuoteOpen({
                  //     show: true,
                  //     rfq_id: opportunity?.rfq_id,
                  //     btnText: "Copy Opportunity",
                  //     label: "Opportunity",
                  //   });
                  // }}
                >
                  <IconCopyCheck />
                </span>
              </OverlayTrigger>
            </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="head_title">
            <h2>ID: {opportunity?.rfq_id}</h2>
            <div className="status_dropdown" style={{ position: "relative" }}>
              <button
                onClick={() => setIsOpen(!isOpen)}
                style={{
                  backgroundColor: selected.color,
                }}
              >
                {selected.label} <IconChevronDown />
              </button>
              {isOpen && (
                <div className="status_dropdown_select">
                  {statusOptions
                    .filter((option) => option.value !== selected.value)
                    .map((option) => (
                      <div
                        className="status_options"
                        key={option.value}
                        onClick={() =>
                          openModal(
                            opportunity?.rfq_id,
                            option.value,
                            opportunity.status,
                          )
                        }
                        style={{
                          backgroundColor: option.color + "20",
                          cursor: "pointer",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.backgroundColor =
                            option.color + "33")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.backgroundColor =
                            option.color + "20")
                        }
                      >
                        {option.label}
                      </div>
                    ))}
                </div>
              )}
            </div>
            {hasBatchImportAccess && (
            <Button
              className="btn-warning btn-sm"
              onClick={() => setIsUploadOpen(true)}
            >
              <IconUpload size={20} /> Batch Import
            </Button>
            )}
          </div>
          <div className="head_mini_details">
            <div className="flex_profit_row">
              <p className="mb-0">
                <b className="profit_est">Date Created:</b> <IconCalendarWeek />{" "}
                {moment(opportunity?.created_at).format("MM/DD/YYYY")}
              </p>
              <p className="mb-0">
                <b className="profit_est">Date Starts:</b> <IconCalendarWeek />{" "}
                {moment(opportunity?.start_date).format("MM/DD/YYYY")}
              </p>
              <p className="mb-0">
                <b className="profit_est">Date Ends:</b> <IconCalendarWeek />{" "}
                {moment(opportunity?.due_date).format("MM/DD/YYYY")}
              </p>
            </div>
            <div className="flex_profit_row">
              <p className="mb-0">
                <b className="profit_est">Sales Lead:</b> <IconUser />{" "}
                {opportunity?.sales_lead_name || "N/A"}
              </p>
              <p className="mb-0">
                <IconMail /> {opportunity?.sales_lead_email || "N/A"}
              </p>
              <p className="mb-0">
                <IconPhone />
                {opportunity?.sales_lead_phone || "N/A"}
              </p>
              <p className="mb-0">
                <b className="profit_est">Name:</b>{" "}
                {opportunity?.ContractType?.name || "N/A"}
              </p>
            </div>
          </div>
          <div className="full_details">
            <Row className="flex_rows">
              <Col lg={4} md={5}>
                <p className="d-flex align-items-center gap-1">
                  <IconUser stroke={1} width={20} /> KO Name
                </p>
              </Col>{" "}
              <Col lg={8} md={7}>
                <b>{opportunity?.rfqKo?.name || "-"}</b>
              </Col>{" "}
            </Row>
            <Row className="flex_rows">
              <Col lg={4} md={5}>
                {" "}
                <p className="d-flex align-items-center gap-1">
                  <IconPhone stroke={1} width={20} /> Phone Number
                </p>
              </Col>{" "}
              <Col lg={8} md={7}>
                <b>{opportunity?.rfqKo?.phone || "-"}</b>
              </Col>
            </Row>
            <Row className="flex_rows">
              <Col lg={4} md={5}>
                {" "}
                <p className="d-flex align-items-center gap-1">
                  <IconMail stroke={1} width={20} /> Email ID
                </p>
              </Col>{" "}
              <Col lg={8} md={7}>
                {opportunity?.rfqKo?.email ? (
                  <span
                    // onClick={(e) => {
                    //   setIsEmaillOpen({
                    //     title: "Contracting Officer's",
                    //     toName: opportunity?.rfqKo?.name,
                    //     show: true,
                    //     RFQID: opportunity.rfq_id,
                    //     toEmail: opportunity?.rfqKo?.email,
                    //     Quote_No: opportunity?.invoice_no,
                    //     defaultSubject: `${opportunity?.invoice_no}----(CONTRACT VEHICLE)`,
                    //     skuData: opportunity?.RfqProducts,
                    //     row: opportunity,
                    //   });
                    // }}
                    className="text-decoration-underline"
                    style={{ cursor: "pointer" }}
                  >
                    <b>{opportunity?.rfqKo?.email || "-"}</b>
                  </span>
                ) : (
                  <span className="empty_data">
                    <b>-</b>
                  </span>
                )}
              </Col>
            </Row>
            <Row className="flex_rows">
              <Col lg={4} md={5}>
                {" "}
                <p className="d-flex align-items-center gap-1">
                  <IconMapPin stroke={1} width={20} /> Address
                </p>
              </Col>{" "}
              <Col lg={8} md={7}>
                <b>{opportunity?.rfqKo?.address || "-"}</b>
              </Col>
            </Row>
          </div>
          <div className="full_details">
            <Row className="flex_rows">
              <Col lg={4} md={5}>
                <p className="d-flex align-items-center gap-1">
                  <IconUser stroke={1} width={20} /> Customer Name
                </p>
              </Col>
              <Col lg={8} md={7}>
                <b>{opportunity?.rfqShipping?.name || "-"}</b>
              </Col>
            </Row>
            <Row className="flex_rows">
              <Col lg={4} md={5}>
                <p className="d-flex align-items-center gap-1">
                  <IconPhone stroke={1} width={20} /> Phone Number
                </p>
              </Col>{" "}
              <Col lg={8} md={7}>
                <b>{opportunity?.rfqShipping?.phone || "-"}</b>
              </Col>
            </Row>
            <Row className="flex_rows">
              <Col lg={4} md={5}>
                {" "}
                <p className="d-flex align-items-center gap-1">
                  <IconMail stroke={1} width={20} /> Email ID
                </p>
              </Col>{" "}
              <Col lg={8} md={7}>
                {opportunity?.rfqShipping?.email ? (
                  <span
                    // onClick={(e) => {
                    //   setIsEmaillOpen({
                    //     title: "Customer Details",
                    //     toName: opportunity?.rfqShipping?.name,
                    //     show: true,
                    //     RFQID: opportunity.rfq_id,
                    //     toEmail: opportunity?.rfqShipping?.email,
                    //     Quote_No: opportunity?.invoice_no,
                    //     defaultSubject: `${opportunity?.invoice_no}----(CONTRACT VEHICLE)`,
                    //     skuData: opportunity?.RfqProducts,
                    //     row: opportunity,
                    //   });
                    // }}
                    className="text-decoration-underline"
                    style={{ cursor: "pointer" }}
                  >
                    <b>{opportunity?.rfqShipping?.email || "-"}</b>
                  </span>
                ) : (
                  <span className="empty_data">
                    <b>-</b>
                  </span>
                )}
              </Col>
            </Row>
            <Row className="flex_rows">
              <Col lg={4} md={5}>
                {" "}
                <p className="d-flex align-items-center gap-1">
                  <IconMapPin stroke={1} width={20} /> Address
                </p>
              </Col>{" "}
              <Col lg={8} md={7}>
                <b>{opportunity?.rfqShipping?.address || "-"}</b>
              </Col>
            </Row>
          </div>

          <div className="full_details">
            <Row className="flex_rows">
              <Col lg={4} md={5}>
                <p className="d-flex align-items-center gap-1">
                  <IconUser stroke={1} width={20} /> (POC) Name
                </p>
              </Col>
              <Col lg={8} md={7}>
                <b>{opportunity?.point_of_contact?.name || "-"}</b>
              </Col>
            </Row>
            <Row className="flex_rows">
              <Col lg={4} md={5}>
                <p className="d-flex align-items-center gap-1">
                  <IconPhone stroke={1} width={20} />
                  (POC) Phone Number
                </p>
              </Col>
              <Col lg={8} md={7}>
                <b>{opportunity?.point_of_contact?.phone || "-"}</b>
              </Col>
            </Row>
            <Row className="flex_rows">
              <Col lg={4} md={5}>
                <p className="d-flex align-items-center gap-1">
                  <IconMail stroke={1} width={20} /> (POC) Email ID
                </p>
              </Col>
              <Col lg={8} md={7}>
                <b>{opportunity?.point_of_contact?.email || "-"}</b>
                {/* {opportunity?.rfqShipping.email ? (
                                    <span
                                        onClick={(e) => {
                                            setIsEmaillOpen({
                                                title: "Customer Details",
                                                toName: opportunity?.rfqShipping?.name,
                                                show: true,
                                                RFQID: opportunity.rfq_id,
                                                toEmail: opportunity?.rfqShipping?.email,
                                                Quote_No: opportunity?.invoice_no,
                                                defaultSubject: `${opportunity?.invoice_no}----(RFQ)`,
                                                skuData: opportunity?.RfqProducts,
                                                row: opportunity,
                                            });
                                        }}
                                        className="text-decoration-underline"
                                        style={{ cursor: "pointer" }}
                                    >
                                        <b>{opportunity?.rfqShipping.email || "-"}</b>
                                    </span>
                                ) : (
                                    <span className="empty_data">
                                        <b>-</b>
                                    </span>
                                )} */}
              </Col>
            </Row>
          </div>
          <div className="attetchment_row">
            <p>
              <IconPaperclip stroke={1} width={20} /> Attachments{" "}
              <span>({opportunity?.Attachments.length})</span>
            </p>
            <div className="carousel-container">
              {opportunity?.Attachments &&
              opportunity?.Attachments.length > 0 ? (
                <>
                  <Swiper
                    slidesPerView={3}
                    spaceBetween={15}
                    loop={true}
                    navigation={true}
                    modules={[Navigation]}
                    className="mySwiper"
                  >
                    {opportunity?.Attachments.map((item, index) => {
                      const fileExtension = item.original_name
                        .split(".")
                        .pop()
                        .toLowerCase();

                      let fileIcon;
                      if (fileExtension === "pdf") {
                        fileIcon = (
                          <IconFileTypePdf
                            stroke={1}
                            width={45}
                            height={45}
                            style={{ color: "#D63939" }}
                          />
                        );
                      } else if (
                        [
                          "jpg",
                          "jpeg",
                          "png",
                          "gif",
                          "bmp",
                          "svg",
                          "webp",
                        ].includes(fileExtension)
                      ) {
                        fileIcon = (
                          <IconPhoto
                            stroke={1}
                            width={45}
                            height={45}
                            style={{ color: "#AE3EC9" }}
                          />
                        );
                      } else {
                        fileIcon = (
                          <IconFileTypeDoc
                            stroke={1}
                            width={45}
                            height={45}
                            style={{ color: "#4299E1" }}
                          />
                        );
                      }
                      return (
                        <SwiperSlide key={index} className="mySwiper">
                          <div className="card">
                            {item.type === "LINK" ? (
                              <a
                                href={item?.file_name}
                                target="_blank"
                                className="attetch_flex"
                              >
                                <IconLink
                                  stroke={1}
                                  width={45}
                                  height={45}
                                  style={{ color: "#4299E1" }}
                                />
                                <div className="attetch_info">
                                  <b>{item.original_name}</b>
                                  <p className="d-flex gap-3 mb-0">
                                    <span>LINK</span>
                                  </p>
                                </div>
                              </a>
                            ) : (
                              <div className="attetch_flex">
                                <div>{fileIcon}</div>
                                <div
                                  className="attetch_info"
                                  // onClick={(e) => {
                                  //   downloadImage(e, item.file_name);
                                  // }}
                                >
                                  <b>{item.original_name}</b>
                                  <p className="d-flex gap-3 mb-0">
                                    <span
                                      onClick={(e) => {
                                        viewAttachment(e, item?.id);
                                      }}
                                    >
                                      Download
                                    </span>
                                    <span
                                      className="text-blue"
                                      // href={`${IMG}uploads/attachments/${item.file_name}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      onClick={(e) => {
                                        viewAttachment(e, item?.id);
                                      }}
                                    >
                                      Preview
                                    </span>
                                  </p>
                                </div>
                              </div>
                            )}
                          </div>
                        </SwiperSlide>
                      );
                    })}
                  </Swiper>
                </>
              ) : (
                <p>No Attachments available</p>
              )}
            </div>
          </div>

          <div className="tabs_details">
            <Tabs
              defaultActiveKey="General"
              id="uncontrolled-tab-example"
              className="mb-3"
            >
              <Tab eventKey="General" title={`General`}>
                <div className="full_details border-0 p-0">
                  {/* <Row className="flex_rows">
                                        <Col lg={4} md={5}>
                                            <p className="d-flex align-items-center gap-1">
                                                Project Type:
                                            </p>
                                        </Col>{" "}
                                        <Col lg={8} md={7}>
                                            <b>{opportunity?.opportunity_type}</b>
                                        </Col>{" "}
                                    </Row> */}
                  <Row className="flex_rows">
                    <Col lg={4} md={5}>
                      {" "}
                      <p className="d-flex align-items-center gap-1">Name:</p>
                    </Col>{" "}
                    <Col lg={8} md={7}>
                      <b>{opportunity?.opportunity_name || "N/A"}</b>
                    </Col>
                  </Row>
                  <Row className="flex_rows">
                    <Col lg={4} md={5}>
                      {" "}
                      <p className="d-flex align-items-center gap-1">
                        Customer Name:
                      </p>
                    </Col>{" "}
                    <Col lg={8} md={7}>
                      <b>{opportunity?.organization_name || "N/A"}</b>
                    </Col>
                  </Row>
                  <Row className="flex_rows">
                    <Col lg={4} md={5}>
                      {" "}
                      <p className="d-flex align-items-center gap-1">Budget:</p>
                    </Col>{" "}
                    <Col lg={8} md={7}>
                      <b>{opportunity?.project_budget || "N/A"}</b>
                    </Col>
                  </Row>
                  <Row className="flex_rows">
                    <Col lg={4} md={5}>
                      {" "}
                      <p className="d-flex align-items-center gap-1">
                        Project Duration:
                      </p>
                    </Col>{" "}
                    <Col lg={8} md={7}>
                      <b>{opportunity?.project_duration || "N/A"} Days</b>
                    </Col>
                  </Row>
                  <Row className="flex_rows">
                    <Col lg={12} md={12}>
                      {" "}
                      <p>
                        <b className="d-block" style={{ color: "#000" }}>
                          Project Description:{" "}
                        </b>
                        {opportunity?.brief || "N/A"}
                      </p>
                    </Col>{" "}
                  </Row>
                </div>
              </Tab>
              {/* <Tab
                eventKey="Products"
                title={
                  <>
                    Products{" "}
                    <span className="badge bg-indigo-lt">
                      {opportunity?.RfqProducts.length}
                    </span>
                  </>
                }
              >
                {opportunity?.RfqProducts.map((product) => (
                  <div md={12} key={product.id}>
                    <Card className="status_item_card w-100">
                      <Card.Body>
                        <div className="rfq_card_row">
                          <div className="rfq_item_card">
                            <div className="value_card">Vendor Name</div>
                            <p className="label_card">
                              {product.Vendor
                                ? product.Vendor.display_name
                                : "N/A"}
                            </p>
                          </div>
                          <div className="rfq_item_card">
                            <div className="value_card">SKU ID</div>
                            <p className="label_card">
                              {product.sku_display_name || "N/A"}
                            </p>
                          </div>
                        </div>
                        <div className="rfq_card_row">
                          <div className="rfq_item_card">
                            <div className="value_card">Aspetto Cost</div>
                            <p className="label_card">
                              $
                              {product.aspetto_price
                                ? product.aspetto_price
                                : "N/A"}
                            </p>
                          </div>
                          <div className="rfq_item_card">
                            <div className="value_card">Total Cost</div>
                            <p className="label_card">
                              $
                              {product.total_price
                                ? product.total_price
                                : "N/A"}
                            </p>
                          </div>
                        </div>
                        <div className="rfq_card_row mb-0">
                          <div className="rfq_item_card">
                            <div className="value_card">
                              Product Description
                            </div>
                            <p className="label_card mb-0">
                              {product.description ||
                                "No description available"}
                            </p>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </div>
                ))}
              </Tab> */}
              <Tab
                eventKey="Notes"
                title={
                  <>
                    Notes{" "}
                    <span className="badge bg-indigo-lt">{totalNotes}</span>
                  </>
                }
              >
                {opportunity?.section.length === 0 ? (
                  <div className="data_not_available text-center pb-4">
                    <Lottie animationData={notfoundData} />{" "}
                    <p>No notes available</p>
                  </div>
                ) : (
                  opportunity?.section.map((section) => (
                    <div key={section.id}>
                      {section.notes.length > 0
                        ? section.notes.map((note) => (
                            <Card
                              className="status_item_card w-100"
                              key={note.id}
                            >
                              <Card.Body>
                                <div className="flex_note_head mb-1">
                                  <span className="badge bg-indigo-lt">
                                    {section?.name.charAt(0).toUpperCase() +
                                      section?.name.slice(1)}
                                    .
                                  </span>
                                  <div className="note_info_time">
                                    <span className="note_user">
                                      <IconUserCircle /> {note.User.first_name}{" "}
                                      {note.User.last_name}
                                    </span>
                                    <p className="note_user mb-0">
                                      <IconClockHour3 />{" "}
                                      {moment(note.createdAt).format(
                                        "MM/DD/YYYY hh:mm A",
                                      )}
                                    </p>
                                  </div>
                                </div>
                                <p className="mb-0">{note.note}</p>
                              </Card.Body>
                            </Card>
                          ))
                        : null}
                    </div>
                  ))
                )}
              </Tab>
              {/* <Tab
                eventKey="Vendors"
                title={
                  <>
                    Price Change
                    <span className="badge bg-indigo-lt">
                      {opportunity?.RfqPriceChanges?.length}
                    </span>
                  </>
                }
              >

                {opportunity?.RfqPriceChanges?.map((change) => (
                  <div key={change.id}>
                    <Card className="status_item_card w-100">
                      <Card.Body>
                        <Row className="flex_rows">
                          <Col lg={12} md={12}>
                            <p className="d-flex align-items-center gap-1 mb-0">
                              SKU ID:
                              <b style={{ color: "var(--tblr-blue)" }}>
                                {change?.Product?.sku_display_name
                                  ? change?.Product?.sku_display_name
                                  : "N/A"}
                              </b>
                            </p>
                            <p className="mt-0">
                              Description:{" "}
                              {change?.Product?.description
                                ? change?.Product?.description
                                : "N/A"}
                            </p>
                          </Col>
                        </Row>
                        <Row className="flex_rows">
                          <Col lg={2} md={5}>
                            <p className="d-flex align-items-center gap-1">
                              From date:
                            </p>
                          </Col>
                          <Col lg={10} md={7}>
                            <b> {change.from_date || "N/A"}</b>
                          </Col>
                        </Row>

                        <Row className="flex_rows">
                          <Col lg={2} md={5}>
                            <p className="d-flex align-items-center gap-1">
                              End Date
                            </p>
                          </Col>
                          <Col lg={10} md={7}>
                            <b>{change.to_date ? change.to_date : "N/A"}</b>
                          </Col>
                        </Row>

                        <Row className="flex_rows">
                          <Col lg={2} md={5}>
                            <p className="d-flex align-items-center gap-1 m-0">
                              Price :
                            </p>
                          </Col>
                          <Col lg={10} md={7}>
                            <b>
                              $
                              {change.customer_price != null &&
                                !isNaN(change.customer_price)
                                ? Number(change.customer_price)
                                : "N/A"}
                            </b>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  </div>
                ))}
              </Tab> */}
            </Tabs>
          </div>
          {isEmaillOpen.show && (
            <KOorCustomerEmailDialog
              pagetitle={isEmaillOpen.title}
              toEmail={isEmaillOpen.toEmail}
              toName={isEmaillOpen.toName}
              RFQID={isEmaillOpen.RFQID}
              show={isEmaillOpen.show}
              skuData={isEmaillOpen.skuData}
              row={isEmaillOpen.row}
              defaultSubject={isEmaillOpen.defaultSubject}
              Quote_No={isEmaillOpen.Quote_No}
              setShow={setIsEmaillOpen}
              setIsSuccsessModalOpen={setIsSuccsessModalOpen}
            />
          )}

          {/* {isCopyQuoteOpen.show && (
            <CopyOpportunityDialog
              module_id={isCopyQuoteOpen.rfq_id}
              show={isCopyQuoteOpen.show}
              onCopy={handleCopy_Quote}
              setShow={setIsCopyQuoteOpen}
            />
          )} */}
        </Offcanvas.Body>
      </Offcanvas>

      {/* {
                isPriceOpen.show && (
                    <PriceChangesModal
                        show={isPriceOpen?.show}
                        setShow={setIsPriceOpen}
                        data={opportunity}
                        onSuccessFetch={fetchData}
                    />
                )
            } */}

      <ComanConfirmationModal
        show={isModalOpen.show}
        onHide={() => {
          setIsModalOpen({ ...isModalOpen, show: false });
          setIsOpen(false);
        }}
        title={isModalOpen.title}
        message={isModalOpen.message}
        onConfirm={isModalOpen.onConfirm}
        icon={isModalOpen.icon}
        type={isModalOpen.type}
      />
      <SuccsessMsgModal
        show={isSuccsessModalOpen.show}
        onHide={() =>
          setIsSuccsessModalOpen(
            { ...isSuccsessModalOpen, show: false },
            // navigate("/dashboard")
          )
        }
        title={isSuccsessModalOpen?.title}
        btntext={isSuccsessModalOpen?.btntext}
        message={isSuccsessModalOpen?.message}
      />
    </>
  );
}

export default View_ProjectDetails;
